<script setup>
import { useQuasar } from 'quasar'
import { ref, toRefs } from 'vue'
import apiDashboard from '../../../api/dashboard.api'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const $q = useQuasar()

const props = defineProps({
  type: String,
  icon: String
})

const { type, icon } = toRefs(props)
const data = ref(0)

const fetch = async () => {
  try {
    const { data: { total } } = await apiDashboard.getTotal(type.value)

    data.value = total
  } catch (error) {
    console.log(error)
  }
}

fetch()
</script>

<template lang='pug'>
.total-container.q-pa-md
  q-card.cursor-pointer(
    bordered 
    @click='fetch'
  )
    q-card-section.text-center.text-white
      q-icon.text-primary(:name="icon" size='2rem')
      .text-h6.text-primary.text-bold {{ data }}
      .text-subtitle2.text-bold {{ t(`dashboard.total.${type}`) }}
</template>